import {ColDef, ValueFormatterParams, ValueParserParams} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import ValueFormatterFactory from "@/utils/UIConstants/ValueFormatterFactory.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import AGGridListSerialCellRenderer from "@/components/inputs/AGGridListSerialCellRenderer.vue";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewListCellColumn extends AbsAGGridEditViewColumn {
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    let valueFormatter = ValueFormatterFactory.fromFieldType(FieldType.BigText);
    let specs = this.createSpecs();
    colDef.valueFormatter = (params: ValueFormatterParams) => {
      return valueFormatter.format(specs, params.value);
    };
    colDef.valueParser = (params: ValueParserParams) => {
      return valueFormatter.parse(specs, params.newValue, params.oldValue);
    };
    colDef.wrapText = true;
    colDef.maxWidth = window.innerWidth * 0.3;
    colDef.cellEditor = 'agLargeTextCellEditor';
    colDef.cellEditorParams = {
      maxLength: 1000000,
    };
    colDef.cellRenderer = AGGridListSerialCellRenderer
    colDef.cellRendererParams = {
      handler: () => this.handler,
      columnMetadata: this.columnMetadata
    }
    colDef.autoHeight = true;
    return [colDef];
  }
}
